export default __webpack_public_path__ + "static/media/X33_CR7_Popout_V1.98ea5b75.png";